import { render } from "./mask.vue?vue&type=template&id=5acb611d&scoped=true&ts=true"
import script from "./mask.vue?vue&type=script&lang=ts"
export * from "./mask.vue?vue&type=script&lang=ts"

import "./mask.vue?vue&type=style&index=0&id=5acb611d&lang=scss&scoped=true"

import exportComponent from "D:\\phpstudy_pro\\WWW\\tengxunshipin\\chat-example\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5acb611d"]])

export default __exports__